import {useFetch} from "../useFetch";
import {TypeContainerPlatforms} from "../../types/api/guide/typeContainerPlatform.types";
import {typeContainerPlatformsService} from "../../services/guide/typeContainerPlatforms-service";

export const useFetchGetTypeCPById = (id?: string) => {


    const { isLoading, error, data } =
        useFetch<TypeContainerPlatforms>(
            typeContainerPlatformsService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as TypeContainerPlatforms, isLoading, error };
}